import { Injectable, signal } from '@angular/core';
import type { NavbarVerticalItem } from '@siemens/element-ng/navbar-vertical';

/**
 * Holds the current set of vertical navbar items displayed by AppComponent.
 * Child routes (e.g. ProjectDetailShellComponent) can push a custom item set
 * on activation and restore the original on destroy.
 */
@Injectable({ providedIn: 'root' })
export class NavbarService {
    /** The items currently rendered by the global si-navbar-vertical. */
    readonly items = signal<NavbarVerticalItem[] | null>(null);

    /** Push a custom item set. Call restore() in ngOnDestroy to revert. */
    override(items: NavbarVerticalItem[]): void {
        this.items.set(items);
    }

    /** Clear the override — AppComponent falls back to its default computed items. */
    restore(): void {
        this.items.set(null);
    }
}
